/**
 * @file  Internal links scroll fix.
 * @author Selectra Front End Team
 * @version 1.0.0
 */

import { scrollToCoordinates } from 'design-system/src/js/00-utilities/scroll-utils';


/**
 * Internal links scroll fix
 */
export default function internalLinksScrollFix() {

  // Menu Header app-config
  const
    menuHeader = document.querySelector( '#ac-menu' ),
    rem = 16;

  if ( menuHeader ) {

    // Get all links and their attribute "href"
    Array.from( document.links )
      .filter( link => {
        const href = link.getAttribute( 'href' );

        return href.startsWith( '#' ) && href.length >= 2;
      })
      .forEach( link => {

        link.addEventListener( 'click', event => {
          event.preventDefault();

          const
            scrollTargetId = event.target.getAttribute( 'href' ).substring( 1 ),
            scrollTargetTop = document.getElementById( scrollTargetId ).getBoundingClientRect().top,
            scrollToPadding = window.innerWidth < 992 ? 0 : rem * 4;

          let scrollPaddingTop = 0;

          if ( menuHeader.querySelector( '.ac-menu--fixed' )) {
            scrollPaddingTop = window.innerWidth < 992 ? 0 : menuHeader.offsetHeight + scrollToPadding;
          } else if (
            menuHeader.querySelector( '.ac-menu-bar--social' ) ||
            menuHeader.querySelector( '.ac-menu-bar--call' ) ||
            menuHeader.querySelector( '.ac-menu-bar--free-call' )
          ) {
            scrollPaddingTop = window.innerWidth < 772 ? 0 : rem * 4;
          }

          scrollToCoordinates(
            undefined,
            ( scrollTargetTop + window.pageYOffset ) - ( scrollPaddingTop ),
            false );

          window.location.href = '#' + scrollTargetId;

        });

      });

  }

}
